import React from 'react';
import { ChevronDown } from 'lucide-react';
import { TOKEN, LINKS } from '../data/mock';

export default function TopNav() {
  return (
    <nav className="top-nav">
      <a href="#hero" className="logo font-sans">
        <img src={TOKEN.coinImage} alt="FISHE" />
        <span>FISHECOIN</span>
      </a>
      <div className="buys font-sans">
        <span className="buy-label">BUY ON:</span>
        <a className="pill" href={LINKS.fomo} target="_blank" rel="noreferrer">FOMO</a>
        <a className="pill" href={LINKS.moonshot} target="_blank" rel="noreferrer">MOONSHOT</a>
        <a className="pill primary" href={LINKS.pumpfun} target="_blank" rel="noreferrer">PUMP.FUN</a>
        <button className="pill" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          LINKS <ChevronDown size={12} />
        </button>
      </div>
    </nav>
  );
}
